export const EQUAL = 1;
export const NOT_EQUAL = 2;
export const LESS_THAN = 3;
export const GREATER_THAN = 4;
export const LESS_THAN_OR_EQUAL_TO = 5;
export const GREATER_THAN_OR_EQUAL_TO = 6;

export const BETWEEN = 7;
export const RESET = 8;
const filterOptions = [    
    {
        id: EQUAL,
        symbol: '\uf52c',
        display: 'equal',
        operator: 'eq'
    }, {
        id: NOT_EQUAL,
        symbol: '\uf53e',
        display: 'not equal',
        operator: 'neq'
    }, {
        id: LESS_THAN,
        symbol: '\uf536',
        display: 'less-than',
        operator: 'lt'
    }, {
        id: GREATER_THAN,
        symbol: '\uf531',
        display: 'greater-than',
        operator: 'gt'
    }, {
        id: LESS_THAN_OR_EQUAL_TO,
        symbol: '\uf537',
        display: 'less-than or equal to',
        operator:'ltoe'
    }, {
        id: GREATER_THAN_OR_EQUAL_TO,
        symbol: '\uf532',
        display: 'greater-than or equal to',
        operator: 'gtoe'
    },
    {
        id:BETWEEN,
        symbol: '\uf07e',
        display: 'between',
        operator: 'between'

    }
    // {
    //     id: RESET,
    //     symbol: '*',
    //     display: 'reset',
    //     operator:'eq'
    // },
    

    //''

];

export default filterOptions;